import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Container } from '@material-ui/core';
import Header from '../components/Header';
import SideMenu from '../components/SideMenu';

const drawerWidth = 260;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    minHeight: '100vh',
    width: '100%',
    overflow: 'hidden',
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
    padding: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2),
    },
    transition: theme.transitions.create(['margin-left'], {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.standard,
    }),
    marginLeft: 0,
    width: '100%',
  },
  contentWithMenu: {
    [theme.breakpoints.up('sm')]: {
      marginLeft: drawerWidth,
    },
  },
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(4),
    transition: theme.transitions.create('max-width', {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.standard,
    }),
  }
}));

const MainLayout = ({ children, isAuthenticated, setIsAuthenticated }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const classes = useStyles();

  const handleToggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <div className={classes.root}>
      <Header 
        isAuthenticated={isAuthenticated} 
        setIsAuthenticated={setIsAuthenticated}
        onMenuClick={handleToggleMenu}
        menuOpen={menuOpen}
      />
      
      {isAuthenticated && (
        <SideMenu 
          open={menuOpen} 
          setOpen={setMenuOpen} 
        />
      )}

      <main 
        className={`${classes.content} ${menuOpen ? classes.contentWithMenu : ''}`}
      >
        <div className={classes.appBarSpacer} />
        <Container 
          maxWidth={false} 
          className={classes.container}
          style={{ 
            maxWidth: menuOpen ? 'calc(100% - 48px)' : 'calc(100% - 48px)'
          }}
        >
          {children}
        </Container>
      </main>
    </div>
  );
};

export default MainLayout; 